import { Notice } from '@teliaee/design-system';
import { observer } from 'mobx-react';
import * as React from 'react';
import BasePollableLoginStore from '../../stores/BasePollableLoginStore';
import useStores from '../../stores/UseStores';

const PollableLoginStatusNotice = ({ pollableLoginStore }: { pollableLoginStore: BasePollableLoginStore }) => {
  const { translate } = useStores().translateStore;
  const { status } = pollableLoginStore;
  if (status !== 'CANCELLED') {
    return null;
  }
  return (
    <Notice>
      <p role="alert">{translate('authentication.cancelled')}</p>
    </Notice>
  );
};

export default observer(PollableLoginStatusNotice);
